<template>
  <div>
    <alert-comp :msg="msgAlert" />
    <div class="row">

      <div class="col-md-12">
        <p v-if="errosValidacao.length" class="erro">
        <b>Favor, verificar o(s) campo(s) abaixo:</b>
        <ul>
        <li v-for="erro in errosValidacao" v-bind:key="erro">{{ erro }}</li>
        </ul>
        </p>
      </div>

      <div class="col-md-2 align-self-top">
        <label>Numero Protocolo:</label>
      </div>
      <div class="col-md-3">
        <the-mask :mask="['##/######/####']" type="text" class="form-control" v-model="numeroProtocolo"/>
        <label v-if="erroValicaoNumeroProtocolo" class="erro">*Campo obrigatório.</label>
      </div>

      <div class="col-md-2 align-self-top">
        <label>Data de Criação:</label>
      </div>
      <div class="col-md-3">
        <input type="date" class="form-control" v-model="dataCriacao">
        <label v-if="erroValicaoDataCriacao" class="erro">*Campo obrigatório.</label>
      </div>
      <div class="col-md-2">
        <button class="btn btn-outline-primary" @click.prevent="buscarProtocolo()"> Buscar </button>
      </div>

      <div class="container-xl mt-3">
        <data-table-consulta-comp class="p-2"
          :colNames="colNames"
          :eventBusDataName="eventBusDataName"
          :eventBusDataPaginationName="eventBusPaginationName"
          :dataTableColumn="dataTableColumn"
          :colWidth="colWidth">
          <template v-slot="slotProps">
            <td style="text-align: center; width: 100px !important; white-space: nowrap;">
              <i
                v-tooltip.auto-start="`Receber Processo ${slotProps.itemData.atributos.numeroProcesso}`"
                class="fa fa-folder-o fa-1-5x text-info m-1 link"
                aria-hidden="true"
                v-on:click="receberProtocolo(slotProps.itemData)"
              ></i>
            </td>
          </template>
        </data-table-consulta-comp>
      </div>
    </div>
  </div>
</template>

<script>
import VirtusService from '@/services/VirtusService'
import DestinatarioService from '@/services/DestinatarioService'
import eventBus from '@/uteis/eventBus'
import dataTableConsultaComp from '@/components/data-table-consulta/DataTableConsultaComp'
import DataValues from '@/components/data-table-consulta/DataValues'
import alertComp from '@/components/alert/AlertComp'

export default {
  components: {
    dataTableConsultaComp,
    alertComp
  },

  data () {
    return {
      msgAlert: {
        texto: '',
        type: ''
      },
      numeroProtocolo: '',
      dataCriacao: '',
      processo: {},
      colNames: ['Data Criação', 'Número Protocolo', 'Assunto', 'Ações'],
      eventBusDataName: 'consultaProcessoElaboracaoData',
      eventBusPaginationName: 'consultaProcessoElaboracaoDataPagination',
      colWidth: [10, 20, 60, 10],
      dataTableColumn: [
        {
          column: 'atributos.dataCriacao',
          converter: 'localDate'
        },
        {
          column: 'atributos.numeroProcesso',
          converter: 'protocolo'
        },
        'atributos.assunto'],
      errosValidacao: [],
      erroValicaoNumeroProtocolo: '',
      erroValicaoDataCriacao: '',
      erroValicaoProtocoloApensado: ''
    }
  },

  created () {
    this.virtusService = new VirtusService()
    this.destinatarioService = new DestinatarioService()
  },

  methods: {
    buscarProtocolo () {
      if (this.validarCamposProtocoloExterno()) {
        const data = new Date(this.dataCriacao + 'T00:00:00').toLocaleDateString()
        this.virtusService.buscarProtocoloExterno(this.numeroProtocolo, data).then((res) => {
          this.processo = res.data[0]

          if (!this.processo) {
            this.errosValidacao = []
            this.erroValicaoProtocoloApensado = ''

            this.erroValicaoProtocoloApensado = `O Protocolo "${this.numeroProtocolo}" não pode ser recebido nessa Funcionalidade. Para receber acesse o menu "À Receber"`
            this.errosValidacao.push(this.erroValicaoProtocoloApensado)

            return
          }

          if (this.processo.apensadoEm) {
            this.errosValidacao = []
            this.erroValicaoProtocoloApensado = ''

            this.erroValicaoProtocoloApensado = 'Protocolo está apensado ao processo: ' + this.processo.apensadoEm +
            '. É necessário  buscar pelo Processo Principal.'
            this.errosValidacao.push(this.erroValicaoProtocoloApensado)

            return
          }

          eventBus.$emit(this.eventBusDataName, res)
        }).catch(() => {
          this.errosValidacao = []
          this.erroValicaoProtocoloApensado = ''

          this.erroValicaoProtocoloApensado = 'Aconteceu um problema no sistema, por gentileza tente novamente. Se persistir, chame o suporte'
          this.errosValidacao.push(this.erroValicaoProtocoloApensado)
        })
      }
    },

    receberProtocolo (data) {
      // Valicação criada para não deixar receber protocolos que estão apensados
      if (this.processo.apensadoEm) {
        this.errosValidacao = []
        this.erroValicaoProtocoloApensado = ''

        this.erroValicaoProtocoloApensado = 'Protocolo está apensado ao processo: ' + this.processo.apensadoEm +
        '. É necessário  buscar pelo Processo Principal.'
        this.errosValidacao.push(this.erroValicaoProtocoloApensado)
        return
      }

      if (this.processo.atributos.arquivado) {
        this.errosValidacao = []

        const erro = 'Protocolo está arquivado. Não será possivel o receber.'
        this.errosValidacao.push(erro)
        return
      }

      if (this.processo.atributos.remocao) {
        this.errosValidacao = []

        const erro = 'Protocolo está eliminado. Não será possivel o receber.'
        this.errosValidacao.push(erro)
        return
      }
      const dadosSessao = this.$store.getters.getDadosSessao.sessao

      this.virtusService.getNumeroLote(dadosSessao).then((lote) => {
        const numeroLote = lote.data[0]

        this.destinatarioService.buscarDadosDepartamentais(dadosSessao.idDepartamento).then((dadosEstrutura) => {
          const dadosDepartamentais = dadosEstrutura.data.data[0]
          this.destinatarioService.tramitarRecebimentoProtocoloExterno(this.processo, dadosSessao, dadosDepartamentais, numeroLote).then(res => {
            this.virtusService.receberProcessos(this.processo, dadosSessao).then(res => {
              this.finalizarRecebimento()
            }).catch(err => {
              this.tratarErro(err, 'Ocorreu um erro ao receber o protocolo')
            })
          }).catch(err => {
            this.tratarErro(err, 'Ocorreu um erro ao receber o protocolo')
          })
        }).catch(err => {
          this.tratarErro(err, 'Ocorreu um erro ao receber o protocolo')
        })
      })
    },

    tratarErro (err, msg) {
      console.log(err)
      this.msgAlert.texto = msg
      this.msgAlert.type = 'danger'
    },

    finalizarRecebimento () {
      const dataValues = new DataValues([], undefined, 5)
      eventBus.$emit(this.eventBusDataName, dataValues)

      this.msgAlert.texto = 'Protocolo recebido com sucesso'
      this.msgAlert.type = 'success'

      this.numeroProtocolo = ''
      this.dataCriacao = ''
    },

    validarCamposProtocoloExterno () {
      this.errosValidacao = []
      this.erroValicaoNumeroProtocolo = ''
      this.erroValicaoDataCriacao = ''
      if (!this.numeroProtocolo) {
        this.erroValicaoNumeroProtocolo = 'Necessário preencher numero de protocolo'
        this.errosValidacao.push(this.erroValicaoNumeroProtocolo)
      }
      if (!this.dataCriacao) {
        this.erroValicaoDataCriacao = 'Necessário preencher data de criação'
        this.errosValidacao.push(this.erroValicaoDataCriacao)
      }
      if (!this.errosValidacao.length) {
        return true
      }
    }
  }
}
</script>

<style scoped lang="scss">
.erro {
  color: orange;
}
</style>
